/**
 * Presentation Layer - UploadButton Component
 * アップロードボタンコンポーネント
 */

import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';

/**
 * Props定義
 */
export interface UploadButtonProps {
  /** クリック時のコールバック */
  onClick: () => void;
  /** ローディング中フラグ */
  isLoading?: boolean;
  /** 無効化フラグ */
  isDisabled?: boolean;
  /** ボタンラベル */
  label?: string;
  /** ローディング時のラベル */
  loadingLabel?: string;
}

/**
 * アップロードボタンコンポーネント
 */
export const UploadButton: React.FC<UploadButtonProps> = ({
  onClick,
  isLoading = false,
  isDisabled = false,
  label = 'データを登録',
  loadingLabel = '登録中...',
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={isDisabled || isLoading}
      startIcon={isLoading ? <CircularProgress size={20} /> : <UploadIcon />}
    >
      {isLoading ? loadingLabel : label}
    </Button>
  );
};
